import FullSite from "./full-site";
import { PrematchTemplate } from "../../jamibet/desktop-pages/prematch";

export default function Prematch() {
	return <FullSite><PrematchTemplate /></FullSite>;
}
